import { useEffect, useMemo, useState } from 'react'

import { LocaleType } from '@hhgtech/hhg-components/build/interfaces/types'
import dateLocaleUS from 'date-fns/locale/en-US'
import { useRouter } from 'next/router'

export type UseDateUtilsReturn = {
  localize: any
  locale: any
}


const loadDateLocaleByLang: { [l in LocaleType]?: () => Promise<any> } = {
  'vi-VN': () => import('date-fns/esm/locale/vi'),
}


export function useDateUtils(): UseDateUtilsReturn {
  const { locale: lang = 'en-Us' } = useRouter()
  const [locale, setLocale] = useState(dateLocaleUS)

  useEffect(() => {
    loadDateLocaleByLang[lang as LocaleType]?.().then((mod) => {
      setLocale(mod.default)
    })
  }, [setLocale])

  return useMemo(() => {
    return { localize: locale.localize, locale }
  }, [locale.localize, locale])
}
